// MAESON custom JS — prijsweergave en producttitel verfijning

document.addEventListener('DOMContentLoaded', function () {

  // Verwijder EUR valutacode uit alle prijselementen
  document.querySelectorAll('.price-item').forEach(function (el) {
    if (el.childElementCount === 0) {
      el.textContent = el.textContent.replace(/\s*EUR\s*/g, '').trim();
    }
  });

  // Product page h1: verwijder " - " separator, converteer ALL CAPS naar title case
  document.querySelectorAll('.product__title h1').forEach(function (el) {
    var text = el.textContent.trim();
    if (text.length === 0) return;
    // Vervang " - " door spatie (verwijder harde streep, behoud kleur)
    text = text.replace(/ - /g, ' ');
    // ALL CAPS → Title Case (alleen als gehele tekst uppercase is)
    if (text === text.toUpperCase()) {
      text = text.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
    el.textContent = text;
  });

});
